import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { FiberManualRecord, SmartToy } from '@mui/icons-material';

/**
 * Recording Indicator Component
 * Shows when AI note-taker is actively recording the meeting
 */
function RecordingIndicator({ aiPermission }) {
  // Only show if permission was granted
  if (aiPermission !== true) {
    return null;
  }

  return (
    <Tooltip
      title="This meeting is being recorded by AI note-taker. You will receive a summary via email after the meeting."
      arrow
      placement="bottom"
    >
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          right: 16,
          backgroundColor: 'rgba(239, 68, 68, 0.95)',
          color: 'white',
          borderRadius: 2,
          px: 2,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          zIndex: 10000,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(10px)',
          cursor: 'pointer',
          animation: 'pulse 2s ease-in-out infinite',
          '@keyframes pulse': {
            '0%, 100%': {
              opacity: 1,
            },
            '50%': {
              opacity: 0.8,
            },
          },
        }}
      >
        {/* Animated recording dot */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <FiberManualRecord
            sx={{
              fontSize: 12,
              animation: 'blink 1.5s ease-in-out infinite',
              '@keyframes blink': {
                '0%, 100%': {
                  opacity: 1,
                },
                '50%': {
                  opacity: 0.3,
                },
              },
            }}
          />
          <Typography
            variant="body2"
            fontWeight="bold"
            sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
          >
            REC
          </Typography>
        </Box>

        {/* AI Icon */}
        <SmartToy sx={{ fontSize: 18 }} />

        {/* Label */}
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            display: { xs: 'none', sm: 'block' },
          }}
        >
          AI Note-Taker Active
        </Typography>
      </Box>
    </Tooltip>
  );
}

export default RecordingIndicator;
